import React from "react";
import PropTypes from "prop-types";

export default class Countdown extends React.Component {
  static propTypes = {
    leadingZeroes: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    endTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  };

  constructor(props) {
    super(props);

    const { endTime } = props;

    if (!Number.isInteger(Number.parseInt(endTime))) {
      throw new Error(`Expected ${endTime} to be an integer`);
    }

    const currentTime = this.newDate();

    const secondsRemaining = endTime - currentTime;

    this.state = {
      secondsRemaining,
      endTime,
      currentTime,
      formattedTime: this.formatSecondsToTimeRemaining(secondsRemaining),
    };

    this.startCountdown = this.startCountdown.bind(this);
  }

  componentDidMount() {
    this.timer = setInterval(this.startCountdown, 1000);
  }

  newDate() {
    return Math.floor(Date.now() / 1000);
  }

  addLeadingZero(num) {
    if (!Number.isNaN(num) && Number.parseInt(num) < 10) {
      return `0${num}`;
    }
    return `${num}`;
  }

  formatTime({ days, hours, minutes, seconds }) {
    const { leadingZeroes } = this.props;

    if (leadingZeroes) {
      return {
        days: this.addLeadingZero(days),
        hours: this.addLeadingZero(hours),
        minutes: this.addLeadingZero(minutes),
        seconds: this.addLeadingZero(seconds),
      };
    } else {
      return { days, hours, minutes, seconds };
    }
  }

  formatSecondsToTimeRemaining(secondsRemaining) {
    const { leadingZeroes } = this.props;
    if (!secondsRemaining || secondsRemaining < 0) {
      return this.formatTime({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
    }

    const days = Math.floor(secondsRemaining / (60 * 60 * 24));
    const hours = Math.floor(secondsRemaining / (60 * 60)) % 24;
    const minutes = Math.floor(secondsRemaining / 60) % 60;
    const seconds = secondsRemaining % 60;

    return this.formatTime({
      days,
      hours,
      minutes,
      seconds,
    });
  }

  startCountdown() {
    const { secondsRemaining, endTime, currentTime, formattedTime } = this.state;
    const { countdownFinished } = this.props;

    const updatedTime = this.newDate();
    const updatedTimeRemaining = endTime - currentTime;

    if (updatedTimeRemaining < 0) {
      if (countdownFinished) {
        countdownFinished();
        clearInterval(this.timer);
      } else {
        this.setState({
          secondsRemaining: 0,
          currentTime: this.newDate(),
          formattedTime: this.formatSecondsToTimeRemaining(updatedTimeRemaining),
        });
      }
    } else {
      this.setState({
        secondsRemaining: updatedTimeRemaining,
        currentTime: updatedTime,
        formattedTime: this.formatSecondsToTimeRemaining(updatedTimeRemaining),
      });
    }
  }

  render() {
    const {
      formattedTime: { days, hours, minutes, seconds },
    } = this.state;

    const { children, className } = this.props;

    return (
      <div className={className ? className : null}>
        {children({ days, hours, minutes, seconds })}
      </div>
    );
  }
}
